import { render } from "./PropAliases.vue?vue&type=template&id=1215d7c5"
import script from "./PropAliases.vue?vue&type=script&lang=js"
export * from "./PropAliases.vue?vue&type=script&lang=js"
script.render = render

export default script